import { useAtomValue } from "jotai"
import { hasAccess, permissionsAtom } from "@store/authAtoms"

export const useHasAccess = (path: string) => {
  const permissions = useAtomValue(permissionsAtom)

  return hasAccess(permissions, path)
}
